export default __webpack_public_path__ + "static/media/sheer.49e1379b.jpg";